import React from "react";
import { Box, Typography } from "@mui/joy";
import { theme } from "styles/theme";

// =========================
// PresetScenarios — clickable bubbles to send canned messages
// =========================

export interface PresetScenario {
  id: string;
  label: string;
  message: string;
  description?: string;
}

const RAW_TEXT_BEGINNING = `다음 글을 활동지로 만들어줘 (소스 마크업: 제목 / 소제목 / 기본 / 버튼):

제목: 변화의 시작

소제목: 위대한 선택
기본: 반갑습니다. 아마 마음이 심하게 흔들리고 힘든 시기를 겪다가 이곳까지 찾아오셨을 겁니다. 그리고 이제는 정말 스스로 변해야겠다고 굳게 마음먹으셨겠지요. 그렇지 않았다면 디스턴싱이 아니라 당장 눈앞의 고통만 가려줄 임시방편을 택하셨을 테니까요.
기본: 진정한 변화를 일궈내겠다고 결심한 그 용기에 진심으로 박수를 보냅니다. 앞으로 100일 동안 이곳에서 내면의 힘을 기르며, 인생의 전환점을 맞이하시게 될 겁니다.

소제목: 마법의 알약
기본: 이곳에는 복잡한 감정을 단숨에 잠재워 줄 마법의 알약은 없습니다. 그저 글 몇 편 읽는 것만으로 엄청난 변화가 일어난다는 헛된 약속도 하지 않겠습니다. 마음을 치유하는 일은 하루아침에 뚝딱 이루어지는 가벼운 과정이 아닙니다.
기본: 하지만 이 프로그램은 당신이 스스로의 치료자가 되어 진정한 변화를 이끌어내도록 도울 수는 있습니다. 이 과정은 상담사나 약물에 기대는 것이 아니라, 내 삶을 이끄는 방법을 배우는 주도적인 훈련이 될 것입니다.
기본: 때로는 이 훈련의 과정 속에서 답답하고 좌절감을 느낄지도 모릅니다. 하지만 인내심을 가지고 끝까지 해낸다면, 그 무엇과도 바꿀 수 없는 단단한 내면의 힘을 얻게 될 것입니다.
기본: 여지껏 삶의 전환점을 맞이한 수많은 사람들도 처음에는 과연 자신이 변할 수 있을지 의심했습니다. 지금 이 단계에서 그런 의문이 드는 것은 매우 당연한 일입니다.
기본: "나도 변화할 수 있을까?" 해보지 않으면 모릅니다. 제대로 해보지 않고 평생 "나도 변화할 수 있을까?"라는 의문을 품고 사시겠습니까, 아니면 이번 기회에 나도 변화할 수 있는지 확실히 알아보시겠습니까?
기본: 변화하기로 마음 먹고 여기까지 온 것이라면, 지금부터는 스스로를 믿고 프로그램을 밟아 나아가보시길 바랍니다. 포기하고 싶은 순간이 찾아오면 언제든 코치 선생님에게 알려주세요. 코치 선생님은 당신이 이 여정을 계속해 나갈 수 있도록 최선을 다해 도울 것입니다.

소제목: 마음속 타인
기본: 누군가 내 옆을 졸졸 따라다니며 부정적이고 비판적인 말을 귓가에 끊임없이 속삭인다고 상상해 보세요. 처음엔 당황해서 꾹 참아보기도 하고, 그래도 멈추지 않으면 조용히 하라고 화도 내보겠지요. 하지만 그는 아랑곳하지 않습니다. 밀어내려 싸우고 애원해 보지만, 결국 괴로워지는 건 나 자신뿐입니다.
기본: 그 목소리는 내가 어찌할 수 없는 것입니다. 하지만 우리는 이러한 사실을 모른채 스스로에게 끔찍한 일을 저지르고 있습니다.
기본: 우린 마음속에 떠오르는 모든 생각과 감정을 밀어내려고 온갖 수를 쓰며 애를 씁니다. 그러다 결국엔 그런 부정적인 목소리를 내는 자신에게 화를 내고, 그것을 막지 못하는 스스로를 자책하며 갉아먹고 있는 것이죠.
기본: 앞으로 100일 동안 다룰 핵심 기술은 바로 '거리두기'입니다. 쉽게 말해, 머릿속에 떠오르는 생각들을 내 옆에 앉은 낯선 사람이 던지는 말이라고 여기는 연습입니다. 이 기술에 익숙해지면 생각을 관찰할 수 있게 되고, 귓가에 어떤 소리가 맴돌든 그로부터 온전히 자유로워질 수 있습니다.
기본: 단, 이것이 단순히 '주변의 잡음처럼 하찮게 여기며 무시하기'를 뜻하진 않는다는 것을 꼭 기억해주세요. 디스턴싱은 그 반대입니다. 하찮게 여기지 않을 것입니다. 그렇다고 소중히 여기지도 않을 것입니다. 판단과 평가 없이 듣고, 있는 그대로를 기꺼이 품을 것입니다. 우리는 앞으로 이 태도를 연습해 나갈 것입니다.
버튼: 디스턴싱을 배우고 나면, 머릿속에 스스로를 깎아내리는 비관적인 생각이 떠올랐을 때 어떻게 대처하게 될까요?
[A. 그 생각이 나의 진짜 모습이자 진실이라고 굳게 믿는다.]
[B. 나와 무관한 주변의 소리로 여기며 판단 없이 지그시 관찰한다.]
[C. 왜 그런 생각을 했는지 스스로를 탓하며 분석한다.]
(오답 시: 활동지를 천천히 살펴본 뒤 다시 답해보세요.)
기본: 정답은 B입니다. 생각은 나의 본질을 의미하지 않습니다. 그저 지금 창 밖에서 들려오는 바람 소리처럼 우연히 스쳐 지나가는 것일 뿐입니다. 이 사실을 꼭 기억해주시길 바랍니다.

소제목: 오래된 펌프
기본: 낯선 개념을 받아들이며 습관을 바로잡는 과정은 오랫동안 쓰지 않은 펌프에서 물을 끌어올리는 일과 비슷합니다. 펌프를 3년이나 방치했다면 그 안에는 엄청난 녹과 먼지가 쌓여 있겠지요. 즉, 누구나 거리두기를 연습하며 내면을 들여다보기 시작하면, 처음에는 흙먼지가 섞인 탁한 물이 쏟아져 나옵니다.
기본: 많은 분들이 이 흙탕물을 보고는 상태가 더 나빠졌다고 지레짐작하며 서둘러 펌프질을 멈춰버립니다. 하지만 이는 고여 있던 찌꺼기가 빠져나오는, 아주 자연스럽고도 꼭 필요한 중간 과정일 뿐입니다. 지금 해야 할 일은 맑은 물이 나올 때까지 멈추지 않고 계속 펌프질을 하는 것입니다.
기본: 당장 거리두기 연습이 고통스럽고 혼란스럽더라도 두려워하거나 멈추지 않아야 합니다. 내면의 탁한 습관들이 모두 흘러가도록 묵묵히 내버려 두면, 마침내 맑고 건강한 습관이 그 자리를 채울 것입니다. 맑은 물을 마시게 되는 그 감격스러운 순간까지 프로그램이 곁에서 돕겠습니다.
버튼: 훈련을 시작한 후, 갑자기 혼란스럽고 부정적인 감정이 쏟아져 나온다면 어떻게 해야 할까요?
[A. 상태가 악화되었다고 판단하고 즉시 훈련을 그만둔다.]
[B. 더 쉽고 빠른 다른 치료법이 없는지 찾아 나선다.]
[C. 자연스러운 과정이라 여기고 훈련을 계속한다.]
(오답 시: 활동지를 천천히 살펴본 뒤 다시 답해보세요.)
기본: 정답은 C입니다. 훈련 과정에서 내면의 찌꺼기가 빠져나오는 것은 자연스럽고 필연적인 현상입니다.

소제목: 100일간의 여정
기본: 이 힘든 시기가 오히려 단단한 성장의 발판이 될 수 있도록 끝까지 함께하겠습니다. 프로그램을 성공적으로 마치게 된다면, 훗날 비슷한 시련이 다시 찾아와도 예전처럼 무너지지 않고 의연하게 이겨낼 수 있을 것입니다. 이 100일간의 뜻깊은 여정 끝에서, 한층 성숙하고 달라진 자신과 마주하시게 될 겁니다.
버튼: 100일간의 디스턴싱 훈련 과정을 통해 얻을 수 있는 것은 무엇일까요?
[A. 당장의 불안과 스트레스를 잊게 해주는 도피처]
[B. 근본적으로 나 자신을 변화시키는 내면의 힘]
[C. 누군가의 조언으로 내 문제를 해결하는 것]
(오답 시: 활동지를 천천히 살펴본 뒤 다시 답해보세요.)
기본: 정답은 B입니다. 디스턴싱은 스스로 만들어내는 가장 확실하고 굳건한 변화를 추구합니다.`;

const RAW_TEXT_DISTANCING = `다음 글을 활동지로 만들어줘 (소스 마크업: 제목 / 소제목 / 기본 / 버튼):

거리두기란 무엇인가

소제목: 마음의 선글라스
기본: 마음이 건강하지 않을 때는 세상을 마치 새까만 선글라스를 끼고 보는 것과 같습니다. 아무리 기분 좋은 일이 생겨도 결국 불안이나 걱정, 깊은 무력감에 빠지고 맙니다. 뇌가 모든 상황을 부정적으로 해석하도록 습관이 들어버렸기 때문입니다.
기본: 이런 상태에서는 머릿속에 떠오르는 부정적인 생각들이 모두 변함없는 진실처럼 느껴집니다. 그 생각들을 곧 '나 자신'이라고 굳게 믿으며 스스로를 옭아매고 자책하게 되죠. 혹시 지금 이렇게 어둡고 긴 터널을 홀로 걷고 계시나요?
기본: 그렇다면 정말 잘 찾아오셨습니다. 이제부터 그 까만 마음의 선글라스를 벗고 본래의 삶을 되찾는 연습을 시작해보려 합니다. 나를 괴롭히던 그 생각들이 사실 '나' 자신이 아니었다는 것을 자연스럽게 깨닫게 될 것입니다.

소제목: 신성한 멈춤
기본: 생각은 순식간에 지나갑니다. 그런 생각을 미처 알아차리기도 전에 우린 이미 그에 반응해서 감정과 감각을 느끼며 어떤 행동을 마친 상태이지요. 이렇게 무의식적으로 반응하는 악순환을 끊어내려면 가장 먼저 '잠시 멈추는 연습'이 필요합니다. 이를 일상 속의 '신성한 멈춤'이라고 합니다.
기본: 신성한 멈춤을 갖게 되면, 생각과 자동 반응 사이의 연결고리가 끊어집니다. 비로소 내 진짜 감정이 두려움인지 슬픔인지 한 걸음 물러서서 관찰할 수 있는 틈이 생기는 것이죠. 다툼이나 갈등이 일어나는 순간에도, 이 멈춤은 현명한 선택을 내릴 수 있는 마음의 여유를 만들어줍니다.
기본: 이러한 멈춤은 마음이 비교적 평온할 때 일상 속에서 미리 연습해 두는 것이 좋습니다. 평소에 충분히 훈련해 두면, 거대한 스트레스가 닥쳐와도 흔들림 없이 차분하게 대처할 수 있습니다.
버튼: 무의식적인 반응을 끊어내기 위해 가장 먼저 해야 할 일은 무엇일까요?
[A. 내 잘못이 무엇인지 자책한다.]
[B. 반박할 말을 머릿속으로 계산한다.]
[C. 긍정적인 상황이라고 세뇌한다.]
[D. 마음속에서 일어나는 일들을 관찰한다.]
(오답 시: 활동지를 천천히 살펴본 뒤 다시 답해보세요.)
기본: 정답은 D입니다. '신성한 멈춤'을 통해 습관적으로 반응하는 연결고리를 끊어낼 수 있습니다.

소제목: 마음의 RAIN
기본: 그렇다면 이 '신성한 멈춤'은 어떻게 실천할 수 있을까요? 신성한 멈춤은 RAIN이라는 방법을 통해 실천할 수 있습니다. RAIN의 과정은 다음과 같습니다.
인지하기 (R, Recognition)
내 마음에서 무슨 일이 일어나는지 알아차리기
수용하기 (A, Acceptance)
마음속에 떠오른 감정이나 생각을 거부하지 않고 온전히 받아들이기
살펴보기 (I, Investigation)
그 마음의 움직임을 어린아이와 같은 호기심으로 가만히 살펴보기
탈동일시 (N, Non-identification)
그 생각들을 나 자신과 동일시하지 않기
기본: 이 네 가지 단계를 거치다 보면, 거센 생각의 소용돌이 속에서도 내가 진정으로 원하는 삶의 방향을 선택할 힘을 얻게 됩니다. 마음에 비바람이 몰아칠 때마다 이 'RAIN'을 떠올려 보세요. 해묵은 마음의 습관과 문제 행동에서 벗어나 자유로워지는 열쇠가 되어줄 것입니다. 앞으로 이 네 가지 과정에 따라 거리두기 기술을 차근차근 연습해 보겠습니다.

소제목: 건강한 마음에 대한 오해
기본: 흔히 마음이 건강해진다는 것을 '늘 긍정적인 생각만 가득한 상태'로 오해하곤 합니다. 하지만 억지로 긍정적인 생각만 하려 애쓰는 것은 그리 좋은 방법이 아닙니다. 일시적인 눈속임에 불과할 뿐만 아니라, 오히려 문제를 악화시킬 수 있기 때문입니다.
기본: 가끔 "아무 생각도 하지 마. 그럼 편해져"라고 말하는 사람들도 있습니다. 하지만 생각을 완전히 없애는 것은 애초에 불가능합니다. 사람의 뇌는 무언가를 '지우는' 방식으로는 작동하지 않으니까요. 따라서 이 역시 효과적인 해결책이 될 수 없습니다.
기본: 이 부분은 나중에 더 자세히 다루겠습니다. 지금은 앞으로 연습할 내용이 '무조건 긍정적으로 생각하기'나 '아무 생각도 하지 않기'가 아니라는 점만 기억해 두시면 충분합니다.

소제목: 새로운 관계
기본: 우리를 견딜 수 없이 힘들게 만드는 진짜 원인은 슬픔이나 불안 같은 '감정' 그 자체가 아닙니다. 그 감정을 다루고 관계 맺는 '방식'에 있습니다. 부정적인 감정이나 생각을 억누르고 없애려고만 하면, 그것들은 더 강하게 마음을 옭아맵니다.
기본: 이제부터는 억지로 생각을 지우려 애쓰는 대신, 마음속에 떠오르는 생각들과 '건강하게 관계 맺는 연습'을 해나갈 것입니다. 생각과 적당한 거리를 두고 유연하게 대처할 수 있게 된다면, 앞으로 어떤 시련이 닥쳐와도 내 삶을 지혜롭게 이끌어갈 수 있을 것입니다.
버튼: 오늘부터 새롭게 연습해 나갈 내용은 무엇일까요?
[A. 매일 스스로에게 긍정적인 말 해주기]
[B. 아무 생각 없이 머릿속을 비워내기]
[C. 마음속 생각 및 감정들과 건강한 관계 맺기]
(오답 시: 활동지를 천천히 살펴본 뒤 다시 답해보세요.)
기본: 정답은 C입니다. 억지로 긍정적인 생각을 하거나 생각을 지우는 것은 불가능하며 효과적이지도 않습니다. 유일한 해결책은 내 생각과 감정을 대하는 관점을 바꾸는 것입니다.`;

const RAW_TEXT_EXPERIENCE_SEPARATION = `다음 글을 활동지로 만들어줘 (소스 마크업: 제목 / 소제목 / 기본 / 버튼 / 이미지):

기술 1: 경험 분리

소제목: 첫 번째 훈련법
기본: 지난 시간에 마음을 인지하는 두 가지 훈련 방법이 있다고 배웠습니다. 기록을 통해 경험을 분리하는 연습과, 명상으로 주의력을 통제하는 훈련이었죠. 오늘은 그중 첫 번째 연습을 본격적으로 시작해 보겠습니다.
기본: 이번 시간에 가장 먼저 배울 핵심 개념은 심리학에서 매우 중요하게 다루는 '경험 분리'입니다. 마음의 작용을 이해하기 위한 아주 기초적인 작업입니다. 스포츠나 악기를 처음 배울 때 기본기가 중요한 것처럼, 이 기본기만 확실히 익혀두어도 마음과 거리 두는 능력이 몰라보게 탄탄해질 것입니다.

소제목: 복잡한 경험 꾸러미
기본: 마음속에 떠오르는 부정적인 생각과 거리를 둔 채 가만히 바라보기란 말처럼 쉽지 않습니다. 현실에서 마주하는 내면의 경험이 단순히 '생각'이라는 단일한 덩어리로만 이루어져 있지 않기 때문입니다.
기본: 사실 마음속에서는 생각과 감정, 신체 반응, 그리고 행동과 충동이 복잡하게 뒤섞여 하나의 거대한 '꾸러미'처럼 한꺼번에 쏟아집니다.
🖼️ (상황 → 경험 꾸러미)
기본: 예를 들어 직장에서 무언가 실수를 한 상황을 떠올려 볼까요? "이번 프로젝트는 나 때문에 다 망했어"라는 생각과 동시에 죄책감이나 불안 같은 강렬한 감정이 파도처럼 밀려옵니다. 가슴이 답답해지거나 머리가 아픈 증상이 나타나기도 하고, 당장이라도 다 포기하고 도망치고 싶다는 충동까지 일어납니다. 이 모든 것이 하나의 꾸러미로 묶여서 다가오는 것이죠.
버튼: 다음 중 내면에서 뭉쳐지는 '경험 꾸러미'의 구성 요소가 아닌 것은 무엇일까요?
[A. 머릿속을 스쳐가는 부정적인 '생각']
[B. 불안하고 초조한 '감정']
[C. 도망치고 싶어지는 '충동']
[D. 실수를 저지른 객관적인 '상황']
(오답 시: 활동지를 천천히 살펴본 뒤 다시 답해보세요.)
기본: 정답은 D입니다. 실수를 저지른 '상황'은 내면의 반응을 촉발하는 외부 사건일 뿐, 경험 꾸러미에 속하지 않습니다. 경험 꾸러미는 특정 상황을 마주했을 때 마음속에서 덩어리져 일어나는 생각, 감정/신체 반응, 행동/충동으로 구성됩니다.

소제목: 끝없는 악순환
기본: 경험 꾸러미 속의 생각, 감정과 신체 반응, 행동과 충동은 멈춰 있지 않고 서로 끊임없이 영향을 주고받습니다. 부정적인 생각이 불안을 증폭시키고, 그 불안은 호흡을 가쁘게 만들어 더 극단적인 생각을 불러오기도 합니다. 마치 엉켜버린 털실 타래처럼 단단하게 뭉쳐서 끝없는 악순환을 만들어냅니다.
기본: 이렇게 얽힌 꾸러미를 그대로 둔 채 생각과 거리를 두기란 거의 불가능합니다. 마음속에 정확히 어떤 생각이 스쳐 지나갔는지 파악하기 어려울 뿐만 아니라, 막연한 감정의 크기가 너무 압도적으로 느껴지기 때문입니다. 따라서 이 거대한 덩어리를 각각의 개별 요소로 가닥가닥 쪼개어 바라보는 연습이 필요합니다.
기본: 위의 직장에서 무언가 실수를 한 상황 예시에서 '경험 꾸러미'를 분리한 모습은 다음과 같습니다.
생각
이번 프로젝트는 나 때문에 다 망했어
감정
죄책감, 불안
신체 반응
가슴이 답답함, 머리가 아픔
행동/충동
포기하고 도망치고 싶었음

소제목: 실전 연습
기본: 이처럼 얽혀 있는 마음의 덩어리를 개별 요소로 해체하는 과정을 '경험 분리'라고 부릅니다. 방법은 간단하지만 효과는 매우 강력합니다. 압도적인 감정에 휩쓸리지 않고 마음을 객관적으로 바라볼 수 있게 돕기 때문입니다.
기본: 앞으로 벅차고 강렬한 감정을 마주하더라도, 일기장에 감정을 쏟아내듯 무작정 적어 내려가는 것은 피하는 게 좋습니다. 그 대신, 객관적인 '상황', 머릿속을 스쳐 간 '생각', 느껴진 '감정과 신체 반응', 그리고 '충동이나 실제 행동'을 명확히 나누어 기록해 보세요.
기본: 이렇게 항목을 구분해 적는 것만으로도 혼란스러웠던 경험 꾸러미의 힘이 약해지고 마음에 여유가 생기는 것을 느낄 수 있습니다. 자, 그럼 다음 활동에서 이 '경험 분리'를 구체적으로 어떻게 실천할 수 있는지 함께 알아보겠습니다.`;

export const PRESET_SCENARIOS: PresetScenario[] = [
  {
    id: "rawToBeginning",
    label: "긴 글 → 활동지 (1)",
    message: RAW_TEXT_BEGINNING,
    description:
      '"변화의 시작" — text(header) × 6 + text(body) × 다수 블록, button_quiz × 3 (각 정답 해설 블록 동반)',
  },
  {
    id: "rawToDistancing",
    label: "긴 글 → 활동지 (2)",
    message: RAW_TEXT_DISTANCING,
    description:
      '"거리두기란 무엇인가" — text(label/body) 페어 + button_quiz × 2',
  },
  {
    id: "rawToExperienceSeparation",
    label: "긴 글 → 활동지 (3)",
    message: RAW_TEXT_EXPERIENCE_SEPARATION,
    description:
      '"기술 1: 경험 분리" — image + text(label/body) × 4 분리 예시 + button_quiz × 1',
  },
  {
    id: "branchingFlow",
    label: "분기 추가",
    message: "분기 버튼 추가해줘 — 두 갈래 경로로",
    description:
      "action 에 button_branch 추가, 옵션의 show_from / restart_from 으로 두 경로 블록 분기 후 합류",
  },
  {
    id: "validate",
    label: "검증",
    message: "현재 활동지 규칙대로 검증해줘",
    description:
      "활동지 invariant 검증 — description[0]=text 고정 / action ≤ 1 / typography_style 위계 / button_branch 시퀀스 무결성",
  },
  {
    id: "addQuiz",
    label: "퀴즈 추가",
    message: "퀴즈 버튼 추가해줘",
    description:
      "마지막 블록 action 에 button_quiz 추가 (is_correct + incorrect_message + 정답 해설 블록 동반)",
  },
  {
    id: "removeBlock",
    label: "블록 삭제",
    message: "마지막 블록 삭제해줘",
    description: "마지막 블록 1개 제거",
  },
  {
    id: "help",
    label: "도움말",
    message: "도움말",
    description: "mock 안내 + 운영 Agent 역할 / v2 contract 규칙 요약",
  },
];

export function PresetScenariosBar({
  onPick,
  disabled,
}: {
  onPick: (scenario: PresetScenario) => void;
  disabled: boolean;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
        px: "12px",
        pt: "8px",
        pb: "4px",
      }}
    >
      <Typography
        level="body-xs"
        sx={{
          fontSize: "10px",
          color: theme.vars.palette.Content.Weak,
          alignSelf: "center",
          mr: "2px",
          fontWeight: 600,
          letterSpacing: "0.04em",
          textTransform: "uppercase",
        }}
      >
        시나리오
      </Typography>
      {PRESET_SCENARIOS.map((scenario) => (
        <Box
          key={scenario.id}
          onClick={() => !disabled && onPick(scenario)}
          title={scenario.description}
          sx={{
            px: "10px",
            py: "4px",
            borderRadius: "999px",
            backgroundColor: theme.vars.palette.Background.Level2,
            border: `1px solid ${theme.vars.palette.Border.Weak}`,
            fontSize: "11px",
            fontWeight: 500,
            color: theme.vars.palette.Content.Medium,
            cursor: disabled ? "not-allowed" : "pointer",
            opacity: disabled ? 0.5 : 1,
            transition: "all 0.15s ease",
            userSelect: "none",
            "&:hover": disabled
              ? {}
              : {
                  backgroundColor: theme.vars.palette.Background.Level1,
                  borderColor: theme.vars.palette.Content.Medium,
                  color: theme.vars.palette.Content.Strong,
                  transform: "translateY(-1px)",
                },
          }}
        >
          {scenario.label}
        </Box>
      ))}
    </Box>
  );
}
